"use strict";

var _slicedToArray = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _assertThisInitialized = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
require("./SequenceBarplot.scss");
var lodash_1 = __importDefault(require("lodash"));
var Utils_1 = require("../common/Utils");
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var SequenceBarplotComponent = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(SequenceBarplotComponent, _react_1$default$Comp);
  function SequenceBarplotComponent(props) {
    var _this;
    _classCallCheck(this, SequenceBarplotComponent);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SequenceBarplotComponent).call(this, props));
    _this.cache = {};
    _this.state = {
      svgHovered: false,
      positionsSelected: [],
      hoverKey: Utils_1.generateUUIDv4()
    };
    _this.handleSvgHover = _this.handleSvgHover.bind(_assertThisInitialized(_this));
    _this.handlePositionHover = _this.handlePositionHover.bind(_assertThisInitialized(_this));
    _this.handlePositionClicked = _this.handlePositionClicked.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   *
   * HELPER FUNCTIONS
   *
   *
   */
  _createClass(SequenceBarplotComponent, [{
    key: "handleSvgHover",
    value: function handleSvgHover(isHovered) {
      this.setState({
        svgHovered: isHovered
      });
    }
  }, {
    key: "handlePositionHover",
    value: function handlePositionHover(event, position, isHovered) {
      var _this$props = this.props,
        onPositionMouseEnter = _this$props.onPositionMouseEnter,
        onPositionMouseLeave = _this$props.onPositionMouseLeave;
      if (isHovered && onPositionMouseEnter) {
        //notify parent listeners
        onPositionMouseEnter(position, event.relatedTarget, this.getBars().barsGroupedByPosition.get(position));
      } else if (!isHovered && onPositionMouseLeave) {
        onPositionMouseLeave(position, event.relatedTarget, this.getBars().barsGroupedByPosition.get(position));
      }
      this.setState({
        positionHovered: isHovered ? {
          position: position,
          element: event.relatedTarget,
          bars: this.getBars().barsGroupedByPosition.get(position)
        } : undefined
      });
    }
  }, {
    key: "handlePositionClicked",
    value: function handlePositionClicked(event, position) {
      var positionsSelected = this.state.positionsSelected;
      var onPositionSelectionChanged = this.props.onPositionSelectionChanged;
      var newPositionsSelected = positionsSelected.some(function (p) {
        return p.position === position;
      }) ? positionsSelected.filter(function (p) {
        return p.position !== position;
      }) : [].concat(_toConsumableArray(positionsSelected), [{
        position: position,
        element: event.relatedTarget,
        bars: this.getBars().barsGroupedByPosition.get(position)
      }]);
      if (onPositionSelectionChanged) {
        onPositionSelectionChanged(newPositionsSelected);
      }
      this.setState({
        positionsSelected: newPositionsSelected
      });
    }
    /**
     * Normalize bars to fall between 0 and POSITION_MAX_HEIGHT in svg space. Obey the
     * fixYMax if specified
     * @param bars the same bars as input, with the "normalizeHeight"
     *             attribute added
     */
  }, {
    key: "normalizeBarHeights",
    value: function normalizeBarHeights(bars) {
      var alignment = this.props.alignment;
      var allValidHeights = bars.reduce(function (acc, bar) {
        if (bar.height !== undefined) {
          acc.push(bar.height);
        }
        return acc;
      }, []);
      var overallMinHeight = Math.min.apply(Math, _toConsumableArray(allValidHeights));
      var overallMaxHeight = Math.max.apply(Math, _toConsumableArray(allValidHeights));
      return bars.map(function (bar) {
        var minHeight = overallMinHeight;
        var maxHeight = bar.dataSeriesSet.plotOptions && bar.dataSeriesSet.plotOptions.fixYMax ? bar.dataSeriesSet.plotOptions.fixYMax(alignment) : overallMaxHeight;
        return Object.assign(Object.assign({}, bar), {
          normalizedHeight: bar.height === undefined ? undefined : (bar.height - minHeight) / (maxHeight - minHeight) * SequenceBarplotComponent.POSITION_VIEWBOX_HEIGHT
        });
      });
    }
    /**
     * Get bars and bar groups.
     * Calls prop.getPositionalInfo to calculate heights for each
     * position. Uses cache to avoid too many updates.
     */
  }, {
    key: "getBars",
    value: function getBars() {
      var _this2 = this;
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        dataSeriesSet = _this$props2.dataSeriesSet;
      var dataSeriesSetChanged = !this.cache.dataSeriesSet || this.cache.dataSeriesSet.find(function (ds, idx) {
        return ds !== dataSeriesSet[idx];
      });
      if (!this.cache.bars || alignment !== this.cache.alignment || dataSeriesSetChanged) {
        this.cache.alignment = alignment;
        this.cache.dataSeriesSet = dataSeriesSet;
        var allBars = [];
        dataSeriesSet.forEach(function (ds) {
          allBars = allBars.concat(ds.getBars(alignment).map(function (bar, idx) {
            return Object.assign(Object.assign({}, bar), {
              position: idx,
              dataSeriesSet: ds,
              normalizedHeight: -1
            });
          }));
        });
        //normalize bars group by group
        this.cache.bars = Object.entries(lodash_1.default.groupBy(allBars, function (bar) {
          return bar.dataSeriesSet.id;
        })).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            categoryId = _ref2[0],
            categoryBars = _ref2[1];
          return _this2.normalizeBarHeights(categoryBars);
        }).flat();
        this.cache.barsGroupedByPosition = Utils_1.mapGroupBy(this.cache.bars, function (bar) {
          return bar.position;
        });
        this.cache.barsGroupedByDataseries = Utils_1.mapGroupBy(this.cache.bars, function (item) {
          return item.dataSeriesSet;
        });
      }
      return {
        bars: this.cache.bars,
        barsGroupedByPosition: this.cache.barsGroupedByPosition,
        barsGroupedByDataseries: this.cache.barsGroupedByDataseries
      };
    }
    /**
     *
     *
     * JSX RENDER FUNCTIONS
     *
     *
     */
    /**
     * Render the tooltip for a particular position.
     */
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var barsObj = this.getBars();
      var tooltipPlacement = this.props.tooltipPlacement;
      var hoverKey = this.state.hoverKey;
      return react_1.default.createElement(react_tooltip_1.default, {
        id: "getBarTooltip-".concat(hoverKey),
        effect: "solid",
        type: "light",
        border: true,
        place: tooltipPlacement,
        getContent: function getContent(pos) {
          var posInt = parseInt(pos);
          var posPlusOne = posInt + 1; // positions should be 1 based, not zero based
          var barsAtPostion = barsObj.barsGroupedByPosition.get(posInt);
          var numValidBars = !barsAtPostion ? 0 : barsAtPostion.reduce(function (acc, bar) {
            return acc + (bar.height !== undefined ? 1 : 0);
          }, 0);
          return numValidBars < 1 ? undefined : react_1.default.createElement("div", {
            className: "bar-position-textblock"
          }, react_1.default.createElement("h1", null, "Position: ", posPlusOne), barsAtPostion.map(function (bar) {
            return react_1.default.createElement("div", {
              className: "dataseries-line ".concat(bar.dataSeriesSet.cssClass),
              key: bar.dataSeriesSet.id
            }, react_1.default.createElement("span", {
              className: "legend-square",
              style: {
                backgroundColor: bar.dataSeriesSet.color ? bar.dataSeriesSet.color : undefined
              }
            }), react_1.default.createElement("span", {
              className: "legend-text"
            }, bar.dataSeriesSet.name, ":", " ", bar.tooltipValueText ? bar.tooltipValueText : bar.height !== undefined ? +bar.height.toFixed(1) : "undefined"));
          }));
        }
      });
    }
    /**
     * Render the bar plot svg, with each bar appearing as a single rectangle.
     * Final form:
     *    <svg ...>
     *      <g position 1>
     *         <rect transparant rectangle for interaction for position 1>
     *         <rect for dataseries 1 position 1>
     *         <rect for dataseries 2 position 1>
     *      </g>
     *      <g position 2>
     *         <rect transparant rectangle for interaction for position 2>
     *         <rect for dataseries 1 position 2>
     *         <rect for dataseries 2 position 2>
     *      </g>
     *   </svg>
     */
  }, {
    key: "renderBarPlot",
    value: function renderBarPlot() {
      var _this3 = this;
      var _this$props3 = this.props,
        alignment = _this$props3.alignment,
        positionWidth = _this$props3.positionWidth,
        height = _this$props3.height;
      var hoverKey = this.state.hoverKey;
      var maxSeqLength = alignment.getMaxSequenceLength();
      var totalWidth = positionWidth * maxSeqLength;
      var barsObj = this.getBars();
      return react_1.default.createElement("svg", {
        preserveAspectRatio: "none",
        viewBox: "0 0 ".concat(maxSeqLength * SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH, " ").concat(SequenceBarplotComponent.POSITION_VIEWBOX_HEIGHT),
        style: {
          width: totalWidth,
          height: height ? height : SequenceBarplotComponent.defaultProps.height
        },
        xmlns: "http://www.w3.org/2000/svg",
        onMouseEnter: function onMouseEnter() {
          return _this3.handleSvgHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.handleSvgHover(false);
        }
      }, Array.from(barsObj.barsGroupedByPosition.entries()).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          pos = _ref4[0],
          bars = _ref4[1];
        var allBarsHeightsAtPosition = bars.reduce(function (acc, bar) {
          if (bar.normalizedHeight !== undefined) {
            acc.push(bar.normalizedHeight);
          }
          return acc;
        }, []);
        var maxBarHeight = allBarsHeightsAtPosition.length < 1 ? 0 : Math.max.apply(Math, _toConsumableArray(allBarsHeightsAtPosition));
        var numDataSeries = barsObj.barsGroupedByDataseries.size;
        var barWidth = (numDataSeries === 1 ? 0.9 : 1 / numDataSeries) * SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH;
        var firstBarOffset = (numDataSeries === 1 ? pos + 0.05 : pos) * SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH;
        return allBarsHeightsAtPosition.length < 1 ? null : react_1.default.createElement("g", {
          transform: "translate(".concat(firstBarOffset, ",0)"),
          className: _this3.state.positionsSelected.some(function (p) {
            return p.position === pos;
          }) ? "position-container selected" : "position-container pos" + pos,
          onClick: function onClick(event) {
            _this3.handlePositionClicked(event, pos);
          },
          onMouseEnter: function onMouseEnter(event) {
            _this3.handlePositionHover(event, pos, true);
          },
          onMouseLeave: function onMouseLeave(event) {
            _this3.handlePositionHover(event, pos, false);
          },
          "data-for": "getBarTooltip-".concat(hoverKey),
          "data-tip": pos,
          "data-class": "barplot-tooltip-container",
          key: "pos_".concat(pos)
        }, bars.reduce(function (acc, bar, dataseriesIdx) {
          if (bar.normalizedHeight !== undefined) {
            acc.push(react_1.default.createElement("rect", {
              className: bar.dataSeriesSet.cssClass,
              style: {
                fill: bar.dataSeriesSet.color ? bar.dataSeriesSet.color : undefined,
                color: bar.dataSeriesSet.color ? bar.dataSeriesSet.color : undefined
              },
              transform: "translate(".concat(dataseriesIdx * 1 / bars.length * SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH, ",").concat(SequenceBarplotComponent.POSITION_VIEWBOX_HEIGHT - bar.normalizedHeight, ")"),
              width: barWidth,
              height: bar.normalizedHeight,
              key: "".concat(bar.position, "_").concat(bar.dataSeriesSet.id)
            }));
          }
          return acc;
          //something off here with typescript and this accumulator.
          //can't specify type as rect
        }, new Array()), react_1.default.createElement("rect", {
          className: "interaction-placeholder",
          transform: "translate(0,".concat(SequenceBarplotComponent.POSITION_VIEWBOX_HEIGHT - maxBarHeight, ")"),
          width: SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH,
          height: maxBarHeight
        }));
      }));
    }
    /*
     *
     *
     * REACT METHODS
     *
     *
     */
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props4 = this.props,
        alignment = _this$props4.alignment,
        dataSeriesSet = _this$props4.dataSeriesSet,
        positionWidth = _this$props4.positionWidth;
      if (!this.cache || alignment !== nextProps.alignment || dataSeriesSet !== nextProps.dataSeriesSet || positionWidth !== nextProps.positionWidth) {
        return true;
      }
      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      react_tooltip_1.default.rebuild();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.state.svgHovered ? "barplot hovered" : "barplot";
      return !this.props.alignment ? null : react_1.default.createElement("div", {
        className: className
      }, this.renderTooltip(), this.renderBarPlot());
    }
  }]);
  return SequenceBarplotComponent;
}(react_1.default.Component);
exports.SequenceBarplotComponent = SequenceBarplotComponent;
SequenceBarplotComponent.POSITION_VIEWBOX_HEIGHT = 100;
SequenceBarplotComponent.POSITION_VIEWBOX_WIDTH = 1;
SequenceBarplotComponent.defaultProps = {
  height: "100px"
};
/*
 *
 *
 * PRE-CONFIGURED BARPLOTS
 *
 *
 */
/**
 * Plot the shannon entropy at each position -sum(p * log p)
 *   - p is the fraction of each upper case letter at the position
 *   - ymax is set to the maximum entropy, which is an equal number
 *     of all upper case letters in the alignment.
 */
SequenceBarplotComponent.SHANNON_ENTROPY_BARPLOT = {
  id: "entropy",
  name: "Entropy",
  cssClass: "barplot-shannon-entropy",
  color: "#000000",
  plotOptions: {
    fixYMax: function fixYMax(al) {
      var allLettersInAlignment = al.getAllUpperAlphaLettersInAlignmentSorted();
      var p = 1 / allLettersInAlignment.length;
      return -1 * allLettersInAlignment.reduce(function (acc) {
        return acc + p * Math.log2(p);
      }, 0);
    }
  },
  getBars: function getBars(al) {
    var toReturn = [];
    var plc = al.getPositionalLetterCounts(true, al.getAllUpperAlphaLettersInAlignmentSorted());
    var maxSeqLength = al.getMaxSequenceLength();
    for (var i = 0; i < maxSeqLength; i++) {
      var singlePlc = plc.get(i);
      if (!singlePlc || Object.keys(singlePlc).length === 0) {
        toReturn.push({
          height: undefined
        });
      } else {
        toReturn.push({
          height: -1 * Object.values(singlePlc).reduce(function (acc, p) {
            return acc + p * Math.log2(p);
          }, 0)
        });
      }
    }
    return toReturn;
  }
};
/**
 * Plot evcouplings style conservation defined as 1 - the shannon entropy
 */
SequenceBarplotComponent.CONSERVATION_BARPLOT = {
  id: "conservation",
  name: "Conservation",
  cssClass: "barplot-conservation",
  color: "#414141",
  plotOptions: {
    fixYMax: function fixYMax(al) {
      return SequenceBarplotComponent.SHANNON_ENTROPY_BARPLOT.plotOptions.fixYMax(al);
    }
  },
  getBars: function getBars(al) {
    var ymax = SequenceBarplotComponent.SHANNON_ENTROPY_BARPLOT.plotOptions.fixYMax(al);
    var entropyBars = SequenceBarplotComponent.SHANNON_ENTROPY_BARPLOT.getBars(al);
    return entropyBars.map(function (entropyBar) {
      return Object.assign(Object.assign({}, entropyBar), {
        height: entropyBar.height === undefined ? undefined : ymax - entropyBar.height
      });
    });
  }
};
/**
 * Plot the Kullback-Leibler (KL) divergence for individual columns in the alignment
 *        S = sum(pk * log(pk / qk)
 *   also see scipy docs:
 *     https://docs.scipy.org/doc/scipy/reference/generated/scipy.stats.entropy.html
 *
 * No maximum is explicitly set (so it because the max value)
 */
SequenceBarplotComponent.KULLBAC_LEIBLER_DIVERGENCE_BARPLOT = {
  id: "kullback-leibler-divergence",
  name: "KL Divergence",
  cssClass: "barplot-kullback-leibler-divergence",
  color: "darkred",
  getBars: function getBars(al) {
    var allLetters = al.getAllUpperAlphaLettersInAlignmentSorted();
    var pk = al.getPositionalLetterCounts(true, allLetters);
    var qk = al.getGlobalAlphaLetterCounts(true, allLetters);
    var toReturn = [];
    var maxSeqLength = al.getMaxSequenceLength();
    var _loop = function _loop() {
      var positionsPk = pk.get(i);
      if (!positionsPk || Object.keys(positionsPk).length === 0) {
        toReturn.push({
          height: undefined
        });
      } else {
        toReturn.push({
          height: allLetters.reduce(function (acc, letter) {
            if (letter in positionsPk) {
              acc += positionsPk[letter] * Math.log(positionsPk[letter] / qk[letter]);
            }
            return acc;
          }, 0)
        });
      }
    };
    for (var i = 0; i < maxSeqLength; i++) {
      _loop();
    }
    return toReturn;
  }
};
/**
 * Plot the number of gaps at each position. The y max is set to
 * the total length of the alignment and not the largest number of
 * gaps.
 */
SequenceBarplotComponent.GAPS_BARPLOT = {
  id: "gaps",
  name: "Gaps",
  cssClass: "barplot-gaps",
  color: "#b7b7b7",
  plotOptions: {
    fixYMax: function fixYMax(alignment) {
      return alignment.getSequences().length;
    }
  },
  getBars: function getBars(al) {
    var toReturn = [];
    var maxSeqLength = al.getMaxSequenceLength();
    for (var i = 0; i < maxSeqLength; i++) {
      var gapCount = al.getGapCountAtColumn(i);
      toReturn.push({
        height: gapCount,
        tooltipValueText: "".concat((gapCount / al.getSequences().length * 100).toFixed(1), "% (").concat(gapCount, ")")
      });
    }
    return toReturn;
  }
};